/**
 * company-store.js
 * 会社やユーザーなどに関連するデータストア
 */

// 会社関連APIリクエスト用I/F
import companyInterface from '@/api/company/company-interface'
// 会社関連API
import companyApi from '@/api/company/company-api'

export default {
  namespaced: true,
  state: {
    companyList: [],
  },
  actions: {
    /**
     * 会社一覧取得取得
     * @param {Object} param0 ストアオブジェクト
     */
    getCompanyList ({commit}) {
      try {
        const companyIf = new companyInterface()
        const queryParameter = companyIf.makeCompanyListGetParameter()
        companyApi.getCompanyList(queryParameter)
          .then((response) => {
            // 取得した会社一覧をストアに設定
            commit('setCompanyList', response.data)
          })
          .catch(error => {
            throw error
          })
      } catch (error) {
        throw error
      }
    },
  },
  mutations: {
    /**
     * 会社一覧セット
     * @param {Object} state ステート
     * @param {Object} companyList 会社一覧
     */
    setCompanyList (state, companyList) {
      state.companyList = companyList
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/company/company-store.js